import React, { useEffect, useRef } from 'react';

interface ButtonElement extends HTMLElement {
  addEventListener(type: 'bdsClick', listener: EventListener): void;
  removeEventListener(type: 'bdsClick', listener: EventListener): void;
}

interface ImageEditButtonProps {
  label: string;
  onEdit: () => void;
  disabled?: boolean;
}

export const ImageEditButton: React.FC<ImageEditButtonProps> = ({ label, onEdit, disabled = false }) => {
  const buttonRef = useRef<ButtonElement | null>(null);

  useEffect(() => {
    const button = buttonRef.current;
    if (!button) return;

    const handleClick = () => onEdit();
    button.addEventListener('bdsClick', handleClick);
    return () => button.removeEventListener('bdsClick', handleClick);
  }, [onEdit]);

  return (
    <bds-button
      ref={buttonRef as any}
      type="button"
      variant="secondary"
      size="short"
      icon-left="edit"
      disabled={disabled}
    >
      {label}
    </bds-button>
  );
};
